import { render, staticRenderFns } from "./ResultsSwiperLayout.vue?vue&type=template&id=031745b4&"
import script from "./ResultsSwiperLayout.vue?vue&type=script&lang=js&"
export * from "./ResultsSwiperLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports